module.exports = __webpack_public_path__ + "img/chat.773313a9.svg";